import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { RequestHeaderModel } from 'src/app/models/request-header.model';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss']
})
export class OrderDetailComponent implements OnInit {

  @Input() data: RequestHeaderModel;

  constructor(
    public dataServ: DataService,
    private mdlctrl: ModalController
  ) { }

  ngOnInit() {
  }

  async close() {
    await this.mdlctrl.dismiss();
  }
}
